import { Theme } from 'styles/Themes'

export const selectStyle = (disabled: boolean | undefined) => ({
  control: () => ({
    background: Theme.pallete.SECONDARY,
    display: 'inline-flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
  }),
  valueContainer: () => ({
    width: '100%',
    display: 'inline-flex',
    justifyContent: 'flex-start',
  }),
  indicatorsContainer: (base: any) => ({
    ...base,
    width: 'auto',
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    padding: 0,
    margin: 0,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    color: disabled ? '#9C948C' : '#070707',

    padding: 0,
    margin: 0,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    svg: {
      width: '22px',
      height: '22px',
    },
  }),
  menu: (styles: any) => ({
    ...styles,
    zIndex: 212,
    backgroundColor: ' #fdfdfd',
    fontSize: '14px',
    lineHeight: '20px',
    fontFamily: 'Roboto',
    textAlign: 'left',
    boxSizing: 'border-box',
    borderRadius: '5px',
    width: '280px',
    border: '0 !important',
    boxShadow: '0 !important',
  }),
  option: (styles: any, { isFocused }: any) => ({
    ...styles,
    backgroundColor: isFocused ? '#F5F4F3' : '#fdfdfd',
    color: '#9C948C',
    fontSize: '14px',
    lineHeight: '20px',
    fontFamily: 'Roboto',
    height: '50px',
    // maxWidth: '280px',
    width: '100%',
    border: 'none',
    paddingLeft: '20px',
    fontStyle: 'normal',
    fontWeight: '400',
    padding: '15px 30px',
    textAlign: 'left',
    overflow: 'hidden',
    display: 'flex',
    lignItems: 'center',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  }),
  menuList: (base: any) => ({
    ...base,
    '::-webkit-scrollbar': {
      width: '8px',
      backgroundColor: '#C4C4C4',
      borderRadius: '50px',
    },
    '::-webkit-scrollbar-track': {
      background: '#fbfbfb',
      border: 0,
    },
    '::-webkit-scrollbar-thumb': {
      width: '8px',
      backgroundColor: '#C4C4C4',
      borderRadius: '50px',
    },
  }),
})
